module.exports = __webpack_public_path__ + "static/media/job-offers.720f8ceb.svg";